<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <app-icon icon="file-alt" class="mr-2" /></i>General
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <app-icon icon="th-large" class="mr-2" /></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <app-icon icon="pencil-alt" class="mr-2" />Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Container relative
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.relative"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Container styling reset
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.reset"
                        />
                    </div>
                </div>

                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-2/5">
                            <label class="text-xs text-grey-darker" for="name">
                            Name
                        </label>
                        </div>
                        <div class="flex-grow w-3/5">
                            <app-field-text
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                name="name"
                                placeholder="Section name"
                                v-model="element.object.settings.name"
                            />
                        </div>
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import FieldText from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-field-text': FieldText,
            'app-toggle-field': ToggleField,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
        },
        props: {
            element: {
                type: Object,
                required: true
            },
            languages: {
                type: Array,
                required: false
            }
        },
        data: () => ({
            fields: {
                name: {
                    name: 'Name',
                    attribute: 'name'
                },
                relative: {
                    name: 'Container relative',
                    attribute: 'relative'
                },
                reset: {
                    name: 'Container reset',
                    attribute: 'reset'
                },
                contained: {
                    name: 'Grid constrained',
                    attribute: 'contained'
                }
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Section.vue